import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

function EditReason({ row, open, triggerFetch, closeDialog }) {
  const theme = useTheme();
  const [reason, setReason] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (row) {
      setReason(row.reason);
    }
  }, [row]);
  const handleSubmit = async () => {
    // Reset errors
    const newErrors = {};

    // Validation checks
    if (!reason.trim()) newErrors.reason = "السبب مطلوب.";
    // If there are errors, set them and prevent submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const editedReason = {
      reason: reason,
    };
    if (row.reason === editedReason.reason) {
      toast.error("لم تقم بتعديل أي شيء!");
      return;
    }
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/discountreason/${row.id}`,
        editedReason,
        {
          withCredentials: true,
        }
      );
      if (res) {
        closeDialog();
        triggerFetch();
        toast.success("تم تعديل سبب الخصم بنجاح!");
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  };
  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          borderRadius: "12px",
          minWidth: "300px",
        },
      }}
    >
      <Box sx={{ padding: "24px 24px 0" }}>
        <Typography variant="h5">تعديل سبب الخصم</Typography>
      </Box>
      <DialogContent>
        <FormControl fullWidth sx={{ padding: "12px 0" }}>
          <TextField
            fullWidth
            label="السبب"
            type="text"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            error={!!errors.reason}
            helperText={errors.reason}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => closeDialog()}
          variant="text"
          color={theme.palette.neutral[900]}
        >
          إغلاق
        </Button>
        <Button onClick={handleSubmit} variant="contained">
          تعديل
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditReason;
